import { render, staticRenderFns } from "./CollageCustomOverlayField.vue?vue&type=template&id=3699feb0&scoped=true&"
import script from "./CollageCustomOverlayField.vue?vue&type=script&lang=js&"
export * from "./CollageCustomOverlayField.vue?vue&type=script&lang=js&"
import style0 from "./CollageCustomOverlayField.vue?vue&type=style&index=0&id=3699feb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3699feb0",
  null
  
)

export default component.exports